import React from "react";

function CriditsIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5714_5709)">
        <path
          d="M12.6638 4.66606V2.66651C12.6638 2.48974 12.5936 2.32021 12.4686 2.19522C12.3436 2.07022 12.1741 2 11.9973 2H3.3326C2.97906 2 2.64 2.14044 2.39001 2.39044C2.14002 2.64043 1.99957 2.97949 1.99957 3.33303C1.99957 3.68657 2.14002 4.02563 2.39001 4.27562C2.64 4.52562 2.97906 4.66606 3.3326 4.66606H13.3303C13.5071 4.66606 13.6766 4.73628 13.8016 4.86128C13.9266 4.98627 13.9968 5.1558 13.9968 5.33257V7.99863M13.9968 7.99863H11.9973C11.6438 7.99863 11.3047 8.13908 11.0547 8.38907C10.8047 8.63906 10.6643 8.97812 10.6643 9.33167C10.6643 9.68521 10.8047 10.0243 11.0547 10.2743C11.3047 10.5243 11.6438 10.6647 11.9973 10.6647H13.9968C14.1736 10.6647 14.3431 10.5945 14.4681 10.4695C14.5931 10.3445 14.6634 10.175 14.6634 9.99818V8.66515C14.6634 8.48838 14.5931 8.31885 14.4681 8.19385C14.3431 8.06886 14.1736 7.99863 13.9968 7.99863Z"
          stroke="#424242"
          strokeWidth="1.33303"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.99957 3.33203V12.6632C1.99957 13.0168 2.14002 13.3558 2.39001 13.6058C2.64 13.8558 2.97906 13.9963 3.3326 13.9963H13.3303C13.5071 13.9963 13.6766 13.926 13.8016 13.8011C13.9266 13.6761 13.9968 13.5065 13.9968 13.3298V10.6637"
          stroke="#424242"
          strokeWidth="1.33303"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5714_5709">
          <rect width="15.9964" height="15.9964" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CriditsIcon;
